module.exports = __webpack_public_path__ + "public/images/header/speakers.cfe3c2a845b78cf73083b6d6241fbfa8.png";